module.exports = __webpack_public_path__ + "199f4a8d5c20cb8be4e20f5471afe491.svg";